<template>
    <article class="restaurant-cta">
        <strong class="title" v-test:title>
            {{ title }}
        </strong>
        <address class="address" v-test:address>
            {{ address }}
        </address>
        <b-button
            variant="primary"
            :to="to"
            size="sm"
            v-test:btn
        >
            {{ $snippet('restaurant_information_button', 'store information') }} <span class="sr-only" v-test:btnSRTitle>- {{ title }}</span>
        </b-button>
    </article>
</template>

<script>
    export default {
        name: 'restaurant-cta',

        props: {
            title: {
                type: String,
                required: true,
            },

            address: {
                type: String,
                required: true,
            },

            to: {
                type: String,
                required: true,
            },
        },
    };
</script>

<style lang="scss" scoped>
    .restaurant-cta {
        display: flex;
        flex-direction: column;
        align-items: center;
        text-align: center;
        height: 100%;
    }

    .title {
        font-size: rem(24px);
        line-height: rem(28.8px);
        font-weight: 700;
        display: block;
    }

    .address {
        font-size: rem(18px);
        line-height: rem(24px);
        margin-bottom: 23px;
    }

    .btn {
        margin-top: auto;
        min-width: 160px;
    }
</style>
